import { appOspSecurity } from "@api/osp";
import log from "logbeacon";
import { arePortfolioUploadAuthHeadersReady } from "../constants/uploadConstants";

/**
 * Modal may mount before `useRequestHeader` populates; fetch fresh credentials at upload time.
 */
export async function resolvePortfolioUploadAuthHeaders(
  authHeaders: Record<string, string>,
): Promise<Record<string, string>> {
  if (arePortfolioUploadAuthHeadersReady(authHeaders)) {
    return authHeaders;
  }

  try {
    const fresh = await appOspSecurity.getRequestHeader();
    if (arePortfolioUploadAuthHeadersReady(fresh)) {
      return fresh;
    }
  } catch (error) {
    log.warn("[PortfolioScreenshot] resolve upload auth headers failed", error);
  }

  return authHeaders;
}
